export const GET_VIP_REWARD = "GET_VIP_REWARD"

export const OPEN_DIALOGUE_VIP_REWARD = "OPEN_DIALOGUE_VIP_REWARD"

export const CLOSE_DIALOGUE_VIP_REWARD = "CLOSE_DIALOGUE_VIP_REWARD"

export const CREATE_VIP_REWARD = "CREATE_VIP_REWARD"

export const UPDATE_VIP_REWARD = "UPDATE_VIP_REWARD"

export const DELETE_VIP_REWARD = "DELETE_VIP_REWARD"





